import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hotel-list-filter__title"
}
const _hoisted_2 = {
  class: "dropdown-field__list",
  role: "menu"
}
const _hoisted_3 = ["onClick", "onKeydown"]

import DropdownField from '@lmt-rpb/DropdownField/DropdownField.vue';
import { computed, ref } from 'vue';
import { useStore } from '@/components/common/store';
import { updateURL } from '@components/common/services/url';
import { formToParams } from '@components/common/services/transform';
import type { SearchFormDataType } from '@interfaces/search-form';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import SelectContentAnalytics from '@/js/modules/analytics/SelectContentAnalytics';

type Props = {
	disabled?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownHotelFilter',
  props: {
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {



const store = useStore();
const { isDesktop } = storeToRefs(useBreakpointStore());
const orderTypes: { name: string; mobileName: string; value: 'Price' | 'Popular' | 'Discount' | 'Reviews' }[] = [
	{ name: 'Beliebtheit', mobileName: 'Beliebtheit', value: 'Popular' },
	{ name: 'Niedrigster Preis', mobileName: 'Preis', value: 'Price' },
	{ name: 'Größte Ersparnis', mobileName: 'Ersparnis', value: 'Discount' },
	{ name: 'Beste Bewertung', mobileName: 'Bewertung', value: 'Reviews' },
];

const orderType = computed({
	get() {
		return store.state.searchMask.sortingHotel;
	},
	set(value: number) {
		store.commit('searchMask/updateFormData', { sortingHotel: orderTypes[value].value });
	},
});
const dropdown = ref<InstanceType<typeof DropdownField> | null>(null);
const formData = computed((): SearchFormDataType => store.state.searchMask);
const proxy = computed(() => {
	const index = orderTypes.findIndex((item) => item.value === orderType.value);
	return index !== -1 ? index : null;
});

const fieldValue = computed((): string => {
	if (proxy.value === null) {
		return '';
	}

	const selectedItem = orderTypes[proxy.value];
	if (!selectedItem) {
		return '';
	}

	return isDesktop.value ? selectedItem.name : selectedItem.mobileName;
});

const handleAnalyticsEvent = (index: number) => {
	SelectContentAnalytics.selectContent({
		cId: 'list_sort',
		cType: 'ux_hotellist_click',
		index: index + 1,
	});
};

const onClick = (index: number, e: MouseEvent | KeyboardEvent) => {
	updateURL(formToParams(formData.value, 'hotelList'));
	orderType.value = index;
	handleAnalyticsEvent(index);
	e.preventDefault();
	dropdown.value?.closeDropdown();
};

const navIndex = ref(0);

const checkNavigate = (e: KeyboardEvent) => {
	const list = document.querySelectorAll('.dropdown-field__button');
	const maxPos = list.length - 1;

	if (e.key === 'ArrowUp') {
		navIndex.value = navIndex.value === 0 ? maxPos : navIndex.value - 1;
	} else if (e.key === 'ArrowDown') {
		navIndex.value = navIndex.value === maxPos ? 0 : navIndex.value + 1;
	}

	(list[navIndex.value] as HTMLButtonElement)?.focus();
};

const handleOutsideClick = () => {
	dropdown.value?.closeDropdown();
};

const handleOpen = (e: KeyboardEvent) => {
	if (e.key === 'Enter' || e.key === ' ') {
		e.preventDefault();
		dropdown.value?.toggleDropdown();
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hotel-list-filter", { 'hotel-list-filter--mobile': !_unref(isDesktop) }])
  }, [
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Sortiert nach "))
      : _createCommentVNode("v-if", true),
    _createVNode(DropdownField, {
      ref_key: "dropdown",
      ref: dropdown,
      modelValue: fieldValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fieldValue).value = $event)),
      class: _normalizeClass(["dropdown--hotel-list-filter", { disabled: _ctx.disabled, 'dropdown--hotel-list-filter--mobile': !_unref(isDesktop) }]),
      placeholder: "Beliebtheit",
      "show-footer": false,
      disabled: _ctx.disabled,
      "show-toggle-icon": _unref(isDesktop),
      label: !_unref(isDesktop) ? 'Sortiert nach' : '',
      "onDropdownField:OutsideClick": handleOutsideClick,
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (handleOpen($event)), ["stop"]), ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (handleOpen($event)), ["stop"]), ["space"]))
      ]
    }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderTypes, (item, index) => {
            return _createElementVNode("li", {
              key: item.name,
              class: "dropdown-field__list-item",
              role: "menuitem"
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["dropdown-field__button", { 'is-selected': proxy.value === index }]),
                type: "button",
                onClick: ($event: any) => (onClick(index, $event)),
                onKeydown: [
                  _withKeys(_withModifiers(($event: any) => (onClick(index, $event)), ["stop"]), ["enter"]),
                  _withKeys(($event: any) => (onClick(index, $event)), ["space"]),
                  _withKeys(_withModifiers(checkNavigate, ["prevent"]), ["up"]),
                  _withKeys(_withModifiers(checkNavigate, ["prevent"]), ["down"])
                ]
              }, _toDisplayString(item.name), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_3)
            ])
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ]),
      _: 2 /* DYNAMIC */
    }, [
      (!_unref(isDesktop))
        ? {
            name: "iconLeading",
            fn: _withCtx(() => [
              _createVNode(FaIcon, {
                class: "dropdown-field__icon",
                icon: ['fa-solid', 'fa-arrow-down-wide-short']
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "class", "disabled", "show-toggle-icon", "label"])
  ], 2 /* CLASS */))
}
}

})